module.exports = __webpack_public_path__ + "static/media/icon-fax.241ddf17.svg";